import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GlobalAppService} from "../../../../../core/commons/global-app.service";
import {DocumentCategoryService} from "../../../../service/repository/document-category.service";
import {DocumentCategory} from "../../../../domain/documentCategory";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MessageSeverity} from "../../../../../core/commons/message-severity";
import {DocumentCategoryView} from "../../../../domain/documentCategoryView";

@Component({
    selector: 'document-category-form',
    templateUrl: './category-form.component.html',
    styleUrls: ['./category-form.component.scss']
})
export class CategoryFormComponent  {

    @Input() display: boolean = false;

    @Output() displayChange: EventEmitter<boolean> = new EventEmitter();

    @Output() onChange: EventEmitter<DocumentCategory> = new EventEmitter();

    update: boolean = false;

    category: DocumentCategory = new DocumentCategory();

    title: string = "Nueva carpeta";

    categoryForm: FormGroup;

    parentCategory: DocumentCategory = null;

    constructor(private messageService: GlobalAppService,
                private formBuilder: FormBuilder,
                private categoryService: DocumentCategoryService) {
        this.categoryForm = this.formBuilder.group({
            id: [null],
            name: ['', Validators.required],
            parentCategory: [null],
            visible: [false],
        });
    }

    @Input('parentCategory')
    set setParentCategory( c : DocumentCategory) {
        if (c) {
            this.parentCategory = Object.assign({},c);
            this.parentCategory.parentCategory = null;
        } else {
            this.parentCategory = null;
        }

    }

    @Input('updateCategory')
    set setUpdateCategory(c : DocumentCategory){
        this.category = c;
        if (this.category){
            this.update = true;
            this.categoryForm.get('id').setValue(this.category.id);
            this.categoryForm.get('name').setValue(this.category.name);
            this.categoryForm.get('visible').setValue(this.category.visible);

            if (this.category.parentCategory) {
                let parent = new DocumentCategory();
                parent.id = this.category.parentCategory.id;
                parent.name = this.category.parentCategory.name;
                this.category.parentCategory = parent;
            }
            this.categoryForm.get('parentCategory').setValue(this.category.parentCategory);

        } else {
            this.update = false;
            this.categoryForm.reset();
        }

        this.title = this.update ? "Cambiar el nombre de la carpeta" : "Nueva carpeta";
    }

    public saveCategory({value, valid}) {
        let c = new DocumentCategory(value);

        if (this.update) {
            this.categoryService.update(c).subscribe(
                c => {
                    this.messageService.sendMsg(MessageSeverity.SUCCESS, "Exito",
                        "La carpeta se modifico correctamente.");
                    this.close(true);
                    this.onChange.emit(c);
                },
                error => {
                    this.messageService.sendMsg(
                        MessageSeverity.ERROR,
                        "Error:",
                        "No se a podido modificar la carpeta."
                    )
                }
            );
        } else {
            if ( this.parentCategory )
                c.parentCategory = new DocumentCategory( {id : this.parentCategory.id } );
            else
                c.parentCategory = null;

            this.categoryService.create(c).subscribe(
                c => {
                    this.messageService.sendMsg(MessageSeverity.SUCCESS, "Exito",
                        "La carpeta se guardo correctamente.");
                    this.close(true);
                    this.onChange.emit(c);
                },
                error => {
                    this.messageService.sendMsg(
                        MessageSeverity.ERROR,
                        "Error:",
                        "No se a podido guardar la carpeta."
                    )
                }
            );
        }
    }

    close( clearModal : boolean = false ) {
        if ( clearModal ) {
            this.categoryForm.reset();
        }
        this.display = false;
        this.displayChange.emit(this.display);
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/repository/explorer/category-form/category-form.component.ts